import * as React   from "react";

import "./templates-grid.scss";

import {faAngleDoubleLeft, faAngleDoubleRight}  from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon}                        from "@fortawesome/react-fontawesome";
import {useEffect, useState}                    from "react";
import {cx}                                     from 'emotion';

import {Template} from "../../common/template/template";

export const TemplatesGrid = ({
    addSearchHistoryRecord,
    agentBenefits,
    agentHasYearlySubscription,
    paywallModal,
    templateDownloadModal,
    templates,
    userLevels,
}) => {
    const [currentPage, setCurrentPage] = useState(1);
    const changePage = (newPage: number) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    const [itemsPerPage, setItemsPerPage] = useState(50);

    const totalPages = Math.ceil(templates.length / itemsPerPage);
    useEffect(() =>
    {
        if (currentPage > totalPages) {
            setCurrentPage(1);
        }
    }, [currentPage, totalPages]);

    const startIndex    = (currentPage - 1) * itemsPerPage;
    const pageTemplates = templates.slice(startIndex, startIndex + itemsPerPage);

    return (
        <div className="tmpg-w0w1">
            <div className="results-container">
                {ResultsInfo({
                    totalResults: templates.length,
                    itemsPerPage,
                    setItemsPerPage,
                    setCurrentPage
                })}
            </div>
            <div className="templates-grid">
                {pageTemplates.map((item: any, i: number) => (
                    <Template key={i} {...{
                        addSearchHistoryRecord,
                        agentBenefits,
                        agentHasYearlySubscription,
                        item,
                        paywallModal,
                        templateDownloadModal,
                        userLevels,
                    }}/>
                ))}
            </div>
            <div className="page-select-container">
                {totalPages > 1 && PageNumbers({currentPage, totalPages, changePage})}
            </div>
        </div>
    );
};

const ResultsInfo = ({itemsPerPage, setCurrentPage, setItemsPerPage, totalResults}:{
    itemsPerPage    : number,
    setCurrentPage  : (value: number) => void,
    setItemsPerPage : (value: number) => void,
    totalResults    : number,
}) => {
    return (
        <div className="results-info">
            <span className="bold-header">{totalResults} RESULTS</span>
            <span className="base-75">Results per Page</span>
            <select
                className="select-pages"
                value={itemsPerPage}
                onChange={(e) => {
                    setItemsPerPage(Number(e.target.value));
                    setCurrentPage(1);
                }}
            >
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
            </select>
        </div>
    );
};

const PageNumbers = ({currentPage, totalPages, changePage}:{
    currentPage : number,
    totalPages  : number,
    changePage  : (value: number) => void,
}) => {
    const handlePageChange = (page: number) => {
        if (page >= 1 && page <= totalPages) {
            changePage(page);
        }
    };

    const generatePageNumbers = () => {
        const pageNumbers = [];
        let startPage = currentPage - 2;
        let endPage = currentPage + 2;

        if (startPage < 1) {
            startPage = 1;
            endPage = Math.min(5, totalPages);
        }
        if (endPage > totalPages) {
            endPage = totalPages;
            startPage = Math.max(1, totalPages - 4);
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }

        return pageNumbers;
    };

    return (
        <div className="page-numbers">
            <div className={cx("back-section", {hidden: currentPage <= 1})}>
                <div className="color-button" onClick={() => handlePageChange(1)}>
                    <FontAwesomeIcon icon={faAngleDoubleLeft} />
                </div>
                <div className="color-button" onClick={() => handlePageChange(currentPage - 1)}>Back</div>
            </div>
            <div className="numbers-section">
                {generatePageNumbers().map((pageNum) => (
                    <div
                        key={pageNum}
                        onClick={() => handlePageChange(pageNum)}
                        className={cx("page-button", {active: currentPage === pageNum})}
                    >
                        {pageNum}
                    </div>
                ))}
            </div>
            <div className={cx("next-section", {hidden: currentPage >= totalPages})}>
                <div className="color-button" onClick={() => handlePageChange(currentPage + 1)}>Next</div>
                <div className="color-button" onClick={() => handlePageChange(totalPages)}>
                    <FontAwesomeIcon icon={faAngleDoubleRight} />
                </div>
            </div>
        </div>
    );
};

